export default __webpack_public_path__ + "images/arrow_right-50442e65ed821cbd4666377aa3e46b98.svg";